"use client";

import type { MouseEvent } from "react";

export type PlatformNavItem = { href: string; label: string };

/**
 * Header nav links with reliable in-page smooth scroll. Next's App Router
 * updates the URL hash on a plain `<a href="/#x">` click but does NOT scroll to
 * the anchor. This intercepts same-page hash links and scrolls to the target,
 * falling back to normal navigation when the target isn't on the current page
 * (e.g. clicking "Pricing"/"Contact" from `/signup`).
 */
export function PlatformNavLinks({ items }: { items: PlatformNavItem[] }) {
  function onClick(e: MouseEvent<HTMLAnchorElement>, href: string) {
    const hashIdx = href.indexOf("#");
    if (hashIdx === -1) return;
    const id = href.slice(hashIdx + 1);
    const el = document.getElementById(id);
    if (!el) return; // target not on this page — let the browser navigate
    e.preventDefault();
    el.scrollIntoView({ behavior: "smooth", block: "start" });
    history.pushState(null, "", `#${id}`);
  }

  return (
    <>
      {items.map((item) => (
        <a
          key={item.href}
          href={item.href}
          onClick={(e) => onClick(e, item.href)}
          className="pf-navlink transition-colors hover:text-accent"
        >
          {item.label}
        </a>
      ))}
    </>
  );
}
